var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.425 57.15C42.975 54 48.225 52.5 54.075 52.5C55.725 52.5 57.375 52.65 58.875 52.8C59.625 52.95 59.775 52.65 59.025 52.2C56.175 50.55 53.025 49.05 49.725 47.7C43.275 45 42.375 42.6 42.375 39.9C42.375 37.2 44.175 34.8 46.275 32.85C50.025 29.4 52.125 24.75 52.125 19.2C52.125 8.85 45.675 0 34.275 0C22.875 0 16.275 8.85 16.275 19.2C16.275 24.75 18.375 29.55 22.125 32.85C24.225 34.8 26.025 37.35 26.025 39.9C26.025 42.45 24.975 45 18.675 47.7C9.375 51.6 0.525 56.1 0.375 64.65C0.375 70.2 4.575 75.15 9.825 75.15H31.125C32.775 75.15 34.125 73.8 34.125 72.15V62.4C34.425 60.3 35.475 58.2 37.425 57.15Z",
    fill: "url(#paint0_linear_298_30629)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.325 66.15C72.225 70.5 61.125 57.15 45.525 63.45C44.325 63.9 43.725 64.95 43.725 66.3V82.35C43.725 84.45 45.525 85.8 47.475 85.2C62.775 80.55 73.875 93.9 88.425 87.9C89.475 87.45 90.375 86.4 90.375 85.05V69C90.375 67.05 88.275 65.55 86.325 66.15ZM67.425 81.15C64.125 81.15 61.425 78.45 61.425 75.15C61.425 71.85 64.125 69.15 67.425 69.15C70.725 69.15 73.425 71.85 73.425 75.15C73.425 78.45 70.725 81.15 67.425 81.15Z",
    fill: "url(#paint1_linear_298_30629)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_30629",
    x1: 0.375,
    y1: 44.7403,
    x2: 90.3747,
    y2: 44.8905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_30629",
    x1: 0.375,
    y1: 44.7403,
    x2: 90.3747,
    y2: 44.8905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenture);
export default __webpack_public_path__ + "static/media/venture.807cd305bd9a4187569f36c95da1b68c.svg";
export { ForwardRef as ReactComponent };